import FormPasswordField from "./FormPasswordField";
import { FormPasswordTextFieldProps } from "./FormPasswordField/types";
import FormTextField from "./FormTextField";
import { FormTextFieldProps } from "./FormTextField/types";
import withField from "./hocs/withField";

export const FormikTextField = withField<FormTextFieldProps>(FormTextField);
export const FormikPasswordField = withField<FormPasswordTextFieldProps>(FormPasswordField);
